<template>
  <div class="vm-expanded" v-loading="loadingContainerDetails">
    <el-row type="flex" :gutter="8" class="mt-20" v-if="!loadingContainerDetails">
      <el-col :span="5">
        <el-row type="flex">
          <el-col class="first-col-margin" :span="1"></el-col>

          <el-col class="high-run-time-risk-header" :span="18">
            <h5 style="color:#000000">Runtime Status</h5>
            <span>Investigate threats connected to this VM:</span>
          </el-col>
        </el-row>
        <el-row type="flex" class="mt-20">
          <el-col class="first-col-margin" :span="1"></el-col>
          <el-col class="high-run-time-risk" :span="18">
            <h5 v-if="details.agentDetails.openToPublicInternet">
              <el-popover
                placement="right"
                width="250"
                trigger="hover"
                visible-arrow="true"
                title="Exposed to Public Internet"
              >
                <el-table class="mt-5" :data="details.agentDetails.openPortRanges">
                  <el-table-column width="100" property="protocol" label="Protocol"></el-table-column>
                  <el-table-column width="100" property="from" label="From"></el-table-column>
                  <el-table-column width="50" property="to" label="To"></el-table-column>
                </el-table>
                <a slot="reference" class="format-link">Exposed Ports!</a>
              </el-popover>
            </h5>
            <router-link
              :to="{
                name: 'account-progressions',
                query: { accountKey: details.agentId, nickName: details.customHostname }
              }"
            >
              <h5>
                <div>
                  <el-col
                    v-if="details.numProgressions !== 0 || details.numDetections !== 0"
                    :span="2"
                    style="margin-left:-24px;"
                    ><img src="/static/images/warning.svg"
                  /></el-col>
                  <el-col v-else class="first-col-margin"></el-col>
                </div>
                <a class="format-link">Progressions: {{ details.numProgressions }}</a>
              </h5>
            </router-link>
            <router-link
              :to="{ name: 'account-iocs', query: { accountKey: details.agentId, nickName: details.customHostname } }"
            >
              <h5>
                <a class="format-link">Detections: {{ details.numDetections }}</a>
              </h5>
            </router-link>
            <!-- <router-link :to="{}">
              <h5>
                <a class="format-link">Privileged Activities: {{ details.numProgressions }}</a>
              </h5>
            </router-link> -->
            <!-- <router-link :to="{}">
              <h5>
                <a class="format-link">Anomalies: {{ details.numProgressions }}</a>
              </h5>
            </router-link> -->
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4">
        <el-row type="flex">
          <el-col :span="18">
            <h5 class="application-content-header" style="color:#000000">Application Context</h5>
            <span class="application-content-header">Insights related to business requirements:</span>
          </el-col>
        </el-row>
        <el-row type="flex" class="mt-20">
          <el-col class="application-context" :span="18">
            <div class="display-block">
              <h5 class="format-text">Instance ID:</h5>
              <span class="value">
                {{ instanceId }}
              </span>
            </div>
            <div class="display-block">
              <h5 class="format-text">VPC:</h5>
              <span class="value">{{ details.agentDetails.vpcId }}</span>
            </div>
            <div class="display-block">
              <h5 class="format-text">OS:</h5>
              <span class="value">{{ details.os ? details.os : 'N/A' }}</span>
            </div>
            <div class="display-block">
              <h5 class="format-text">Public IP:</h5>
              <span class="value">{{ details.publicIp ? details.publicIp : 'N/A' }}</span>
            </div>
            <div class="display-block">
              <h5 class="format-text">Private IP:</h5>
              <span class="value">{{ details.privateIp ? details.privateIp : 'N/A' }}</span>
            </div>
            <div class="display-block">
              <h5 class="format-text">Region:</h5>
              <span class="value">{{ vmRegion }}</span>
            </div>
            <div class="display-block">
              <h5 class="format-text">Security Group(s):</h5>
              <span v-for="securityGroup in securityGroups" :key="securityGroup" class="value">
                <span v-if="securityGroup === securityGroups[securityGroups.length-1]">{{ securityGroup }}<br /></span>
                <span v-else>{{ securityGroup }}&#44; <br /></span>
              </span>
            </div>
            <br />
            <div class="display-block">
              <h5 class="format-text">Tags</h5>
              <span v-for="detail in details.tags" :key="detail" class="value"
                ><span>{{ detail }}<br /></span
              ></span>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="5" v-if="containerDetails">
        <el-row type="flex">
          <el-col :span="18">
            <h5 class="worker-node-receives-header" style="color:#000000">Worker Node</h5>
            <span class="worker-node-receives-header">Receives and executes tasks from manager nodes</span>
          </el-col>
        </el-row>
        <el-row type="flex" class="mt-20">
          <el-col class="worker-node-receives" :span="18">
            <div class="display-block">
              <h5 class="format-text">Cluster:</h5>
              <span class="value">{{ clusterCount }}</span>
            </div>
            <div class="display-block">
              <h5 class="format-text">Pods:</h5>
              <span class="value">{{ podCount }}</span>
            </div>
            <br />
            <router-link :to="{ name: 'account-containers', query: { accountKey: details.agentId } }">
              <h5>
                <a class="format-link">Containers: {{ containerDetails.length }}</a>
              </h5>
            </router-link>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="5">
        <el-row type="flex">
          <el-col class="agent-checklist-agen-header" :span="18">
            <h5 class="display-block" style="color:#000000">Sensor Checklist</h5>
            <span class="display-block">{{ agentStatusText }}</span>
          </el-col>
        </el-row>
        <el-row type="flex" class="mt-20">
          <el-col class="agent-checklist-agen" :span="18">
            <div class="display-block">
              <span class="agent-text">Installed (Version {{ details.agentDetails.agentVersion }})</span>
            </div>
            <div v-if="!(details.state === 'DECOMMISSIONABLE' || details.state === 'OFFLINE')">
              <div class="display-block" v-if="details.upgradeable">
                <span class="agent-text">Needs Upgrade(Version {{ details.iqhubVersion }})</span>
              </div>
              <div class="display-block" v-else>
                <span class="agent-text">Up to Date</span>
              </div>
            </div>
            <div class="display-block" v-if="details.state === 'DECOMMISSIONED'">
              <span class="agent-text">Sensor is Decommissioned</span>
            </div>
            <div class="display-block" v-else-if="details.state === 'OFFLINE'">
              <span class="agent-text">Sensor is Offline</span>
            </div>
            <div class="display-block" v-else-if="details.state === 'DECOMMISSIONABLE'">
              <span class="agent-text">Sensor is Offline and can be Decommissioned</span>
            </div>
            <div class="display-block" v-else>
              <span class="agent-text">No Connection Issues Found</span>
            </div>
            <div v-if="details.isWef">
              <div class="wef-margin">
                <h5 class="wef-sensors">Sensor Type:</h5>
                <br />
                <span class="agent-text">Windows Sensor</span>
              </div>
              <div class="wef-margin">
                <h5 class="wef-sensors">WEF Server:</h5>
                <br />
                <span class="agent-text">{{ details.wefServer }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4">
        <el-row type="flex">
          <div class="display-block">
            <el-button class="btn-more-details" size="medium" round @click="gotoHostDetails">
              <b>More Details</b>
            </el-button>
            <br /><br />
            <!-- <el-button class="btn-pin-to-top" size="medium" round>
              <span class=".pin-to-top"><i class="el-icon-location"></i>Pin to top</span>
            </el-button> -->
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import expandedVmMixin from '@/components/expand/expandedVmMixin'

export default {
  name: 'ProtectedDiscoveredVmDetails',
  mixins: [expandedVmMixin],
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  methods: {},
  created () {
    if (this.details.agentId && _.isEmpty(this.details.containerDetails)) {
      this.loadContainerDetailsByAgentId()
    }
  },
  computed: {
    agentStatusText () {
      let text = 'Sensor is '
      if (['DECOMMISSIONABLE', 'OFFLINE'].includes(this.details.state)) {
        text += 'offline'
      } else {
        text += this.details.upgradeable ? 'active and needs upgrade' : 'active and up to date'
      }

      return text
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.vm-expanded {
  padding: 20px;
  background: var(--aluminum-200);
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #d7dbe0;
  background-color: #f8fcff;
}

.material-icons {
  font-size: 1.3em;
  line-height: 36px;
  vertical-align: middle;
  color: var(--gray-500);
  background: transparent;
}

.el-divider--vertical {
  margin: 0px;
}

>>> .el-button {
  /* background-color: var(--aluminum-800); */
  color: white;
  border-radius: 3px;
  background-color: #77dab4;
  margin-bottom: 20px;
  height: 40px;
  width: 152px;

  a {
    text-decoration: none;
    color: white;
  }
}

.el-icon-location {
  margin-right: 8px;
}

.btn-pin-to-top {
  float: right;
  background-color: #ffffff;
  border: 1px solid #c6cbd2;
  border-radius: 3px;
  color: #454b60;
  font-size: 15px;
  height: 40px;
  width: 152px;
}

.pin-to-top {
  height: 20px;
  width: 74px;
  color: #454b60;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 20px;
}

.first-col-margin {
  width: 9%;
  margin-right: 5px;
}

.display-block-for-container {
  display: block;
  color: #1a90fa;
}

.footer-buttons {
  &.center {
    margin: auto;
  }
}

.high-run-time-risk {
  height: 220px;
  width: 156px;
  color: #1a90fa;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
}

.high-run-time-risk-header {
  /* height: 220px; */
  width: 156px;
}

.format-text {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  display: inline;
  color: #000000;
}

.format-link {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  display: inline;
  color: #1a90fa;
}
.application-context {
  height: 322px;
  width: 175px;
  color: #292c32;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.application-content-header {
  width: 175px;
}

.worker-node-receives {
  height: 160px;
  width: 181px;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
}

.worker-node-receives-header {
  width: 181px;
}

.agent-checklist-agen {
  height: 140px;
  width: 184px;
  color: #292c32;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.agent-checklist-agen-header {
  width: 184px;
}

.agent-text {
  font-size: 13px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 20px;
  display: inline;
}

.rectangle-copy-4-1 {
  box-sizing: border-box;
  height: 354px;
  width: 1296px;
  border: 1px solid #d7dbe0;
  border-radius: 2px;
  background-color: #f8fcff;
}

.btn-more-details {
  float: right;
  height: 40px;
  width: 152px;
}

a {
  text-decoration: none;
}

.warning-alignment {
  width: 9%;
  margin-right: 5px;
}

.wef-margin {
  margin-top: 18px;
}

.wef-sensors {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  display: inline;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/expand/ProtectedDiscoveredVmDetails.vue